import styled, { css } from 'styled-components';

export default styled.div`
  ${({ theme }) => {
  return css`
      background: #F1F6FD;
      box-shadow: inset 4px 0 0 ${theme.colors.red_darker};
      border-radius: 0 8px 8px 0;
      padding: 16px 24px;
      margin-top: 8px;
      span {
        font-weight: 400;    
        font-size: 14px;
        line-height: 24px;
      }
    `;
  }};
`;
